module.exports = __webpack_public_path__ + "static/Biya.fa01c03c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/Biya.jpg
// module id = 1291
// module chunks = 137408898365125